import "./about.css";
import introbg from "../../img/introbg.gif";

const About = () => {
  return (
    <div className="a" id="about">
      <div className="a-left">
        
         <div className="a-card">
          <img
            src={introbg}
            alt=""
            className="a-img"
          />
        </div>
        
      </div>
      <div className="a-right">
        <h1 className="a-title">About Me</h1>
        
        <p className="a-desc">
          Skilled web developer, looking to hone potential in this field,
          possessing innovative and creative skills for personal and organizational growth.
          Good in time management and problem-solving. Open to learning a new skillset.
          Proficient in HTML, CSS, JavaScript,React.
        </p>
        
      </div>
    </div>
  );
};

export default About;
